import React, { useEffect, useState } from 'react';
import { usePqDataManager } from '../../../providers/PqDataManagerProvider';
import { usePageProperties } from '../../../providers/PagePropertiesProvider';
import resolveTncLink from './util/resolveTncLink';
import './TermsLink.css';
import { wrapTrademarkSuperscript } from '../../../../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../../../../utils/rewriteLink/rewriteLink';

export default function TermsLink() {
    const { tncLinkText, tncTarget } = usePageProperties();
    const [resolvedLink, setResolvedLink] = useState<string | undefined>(undefined);

    const {
        pqMappingContent: {
            staticTermsConditionsLink,
            programCode,
            disableTermsAndConditions
        },
    } = usePqDataManager();

    useEffect(() => {
        resolveTncLink(staticTermsConditionsLink, programCode)
            .then(link => setResolvedLink(link))
            .catch(error => console.error('Error resolving TNC link:', error));
    }, []);

    return (
        <>
            {!disableTermsAndConditions && <span>
                <a
                    className='Pqde-DataEntryForm__link Pqde-TermsLink'
                    href={resolvedLink}
                    target={tncTarget}
                >
                    <sup className='Pqde-TermsLink--dagger'>&#8224;</sup>
                    <span>{transformHTMLParserLinks(wrapTrademarkSuperscript(tncLinkText))}</span>
                </a>
            </span>}
        </>

    );
}